// extracted by mini-css-extract-plugin
export var articles = "style-module--articles--2fbd1";
export var label = "style-module--label--e9ef5";
export var latest = "style-module--latest--39e0a";
export var latestInner = "style-module--latestInner--c944b";